import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { UserAuxEffects } from './user-aux.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([UserAuxEffects])],
})
export class UserAuxStoreModule {}
